import { TemplateParamsPlugin } from '@unhead/vue/plugins';
import { injectHead } from '#app/composables/head';
import { defineNuxtPlugin } from '#app/nuxt';

export default defineNuxtPlugin({
  setup() {
    const unhead = injectHead();
    // NOTE: useHeadの `templateParams` や `titleTemplate` を有効にするために必要
    unhead.use(TemplateParamsPlugin);
  },
});
